import styled from 'styled-components'

import { TypeStyle, screenReaderOnly, timingDefault } from '@syconium/little-miss-figgy'

export const Wrapper = styled.div<{ disabled?: boolean }>`
  display: block;
  ${o => (o.disabled ? 'background-color: #f5f5f5;' : null)}
`

export const Body = styled.label<{
  hasValue: boolean
  isInvalid: boolean
}>`
  border-color: ${o =>
    o.isInvalid
      ? o.theme.color.text.critical.on.background
      : o.hasValue
      ? 'black'
      : o.theme.color.stroke.neutral.border.decoration.on.strong};
  border-style: solid;
  border-width: 1px;
  border-radius: ${o => o.theme.spacing(1)};
  box-sizing: border-box;
  display: flex;
  padding: 0 18px;
  transition: border-color ${timingDefault} ease;

  &:focus-within {
    border-color: ${o => (o.isInvalid ? o.theme.color.text.critical.on.background : 'black')};
  }
`

export const Input = styled.input<{ disabled?: boolean }>`
  ${TypeStyle.css.bodySmall}
  border: none;
  display: block;
  letter-spacing: 0.6px;
  outline: none;
  width: 100%;
  line-height: 1.25;
  min-height: 40px;

  /* iOS Safari specific fix to prevent zoom */
  &:focus {
    @supports (-webkit-touch-callout: none) {
      font-size: 16px;
    }
  }

  ${o => (o.disabled ? 'background-color: #f5f5f5; ::placeholder { color: #cccccc; };' : null)}
`

export const LiveRegion = styled.div`
  ${screenReaderOnly};
`

export const CharacterCount = styled.span<{ disabled?: boolean }>`
  align-items: center;
  color: #767676;
  display: ${o => (o.disabled ? 'none' : 'flex')};
  font-size: 11px;
  justify-content: flex-end;
  min-width: 50px;
`
